import { Box, IconButton, styled, Typography } from "@mui/material";
import { formatarNumero } from "../../../../../helpers/masks";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { THandleChangeFile, TImagePreview } from "..";


export default function ImageUploadBox({
    type,
    imageFiles,
    handleFileChange,
}: ImageUploadBoxProps) {
    let atualInput = type === 'logo_image' ? imageFiles.logo_image : imageFiles.cover_image;
    return (
        <Box mt={2} borderRadius={2} border={'1px solid #ccc'} padding={'4px 8px'} display={'flex'} justifyContent={'space-between'}>
            <Box display={'flex'} justifyContent={'center'} flexDirection={'column'}>
                {
                    !atualInput &&
                    <Typography variant='caption' fontWeight={'bold'}>
                        Faça o upload de alguma imagem para utilizar de {type === 'logo_image' ? 'logo' : 'cover'}.
                    </Typography>
                }
                {
                    atualInput instanceof File &&
                    <>
                        <Typography fontWeight={'bold'} variant="subtitle2">{atualInput instanceof File ? atualInput.name : ''}</Typography>
                        <Typography fontWeight={'bold'} variant="subtitle2">{formatarNumero((atualInput instanceof File ? atualInput.size : 0) / 1048576)} MB</Typography>
                    </>
                }
                {
                    typeof atualInput === 'string' &&
                    <Typography variant='caption' fontWeight={'bold'}>
                        O preview do {type === 'logo_image' ? 'logo' : 'cover'} atual está sendo exibido acima.
                    </Typography>
                }
            </Box>
            <Box ml={2} display={'flex'}>
                <IconButton
                    component="label"
                    role={undefined}
                    aria-label="upload"
                    className="upload-icon"
                    color='primary'
                >
                    <FileUploadIcon />
                    <VisuallyHiddenInput onChange={(e) => handleFileChange(type, e.target.files)} type="file" accept=".png, .jpg, .jpeg" />
                </IconButton>
                <IconButton
                    aria-label="delete"
                    className="delete-icon"
                    onClick={() => handleFileChange(type, null)}
                    color="error"
                >
                    <DeleteIcon />
                </IconButton>
            </Box>
        </Box>
    )
}
interface ImageUploadBoxProps {
    type: 'cover_image' | 'logo_image'
    handleFileChange: THandleChangeFile;
    imageFiles : TImagePreview
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});